import { Action } from "generated/models";

type TProps = {
    action: Action;
    handleAddDelay: (order: number) => void;
};

const DelayWarningAction = ({ action, handleAddDelay }: TProps) => {
    return (
        <div
            className="grid-stack-item"
            id={`gs-${action.uuid}`}
            gs-w="12"
            key={`action-${action.uuid}`}
            gs-no-resize="true"
            gs-warning="true"
        >
            <div className="d-flex flex-column action-item align-content-center align-items-center">
                <div className="d-flex text-secondary-orange">
                    <span className="material-icons mr-2">error_outline</span>
                    <p className="text-secondary-orange text-center">
                        Add a delay of minimum 5 seconds here. Executing
                        multiple actions for same timer/actuator may cause
                        conflicts or unexpected behavior.
                    </p>
                </div>
                <button
                    className="text-primary-green-1 profile-link-btn"
                    onClick={() => {
                        handleAddDelay(Number(action.order));
                    }}
                >
                    Add Delay
                </button>
            </div>
        </div>
    );
};

export default DelayWarningAction;
